import { render, staticRenderFns } from "./OrderBinModule.vue?vue&type=template&id=96c3364a"
import script from "./OrderBinModule.vue?vue&type=script&lang=js"
export * from "./OrderBinModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports